/* ============================================================
   BOOTWORLD — Global JavaScript
   Cart Drawer | Wishlist | Quick Add | Mobile Nav | Toast
   ============================================================ */

(function () {
  'use strict';

  const WISHLIST_KEY = 'bw_wishlist';
  const MOCK_CART_KEY = 'bw_cart_items';

  function qs(sel, ctx = document) { return ctx.querySelector(sel); }
  function qsa(sel, ctx = document) { return [...ctx.querySelectorAll(sel)]; }

  function parsePriceToRupees(val) {
    if (typeof val === 'number') {
      return val > 100000 ? Math.round(val / 100) : Math.round(val);
    }
    if (!val) return 19999;
    const str = String(val);
    // Strip currency prefixes ('Rs.', 'Rs', 'INR', '₹')
    const clean = str.replace(/Rs\.?/gi, '').replace(/INR/gi, '').replace(/₹/g, '').trim();
    // Remove commas
    const noCommas = clean.replace(/,/g, '');
    const match = noCommas.match(/\d+(\.\d+)?/);
    if (match) {
      const num = parseFloat(match[0]);
      if (num > 100000 && !str.includes('.')) {
        return Math.round(num / 100);
      }
      return Math.round(num) || 19999;
    }
    return 19999;
  }

  function formatMoney(centsOrRupees) {
    const rupees = parsePriceToRupees(centsOrRupees);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function showToast(msg, duration = 2800) {
    let toast = qs('.bw-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bw-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
  }

  const WISHLIST_ITEMS_KEY = 'bw_wishlist_items_data';

  /* ── Wishlist (localStorage & Page Renderer) ────────────────── */
  const Wishlist = {
    get() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
      catch { return []; }
    },
    getItems() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_ITEMS_KEY)) || []; }
      catch { return []; }
    },
    save(list, items) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      if (items) localStorage.setItem(WISHLIST_ITEMS_KEY, JSON.stringify(items));
    },
    has(id) {
      return this.get().includes(String(id));
    },
    toggle(id, itemData = null) {
      let list = this.get();
      let items = this.getItems();
      const sid = String(id);
      const idx = list.indexOf(sid);

      if (idx === -1) {
        list.push(sid);
        if (itemData) {
          const existingIdx = items.findIndex(i => String(i.id) === sid);
          if (existingIdx === -1) items.push(itemData);
        } else {
          items.push({ id: sid, title: 'Football Cleats', price: '₹24,995', image: '', url: '/collections/all' });
        }
        showToast('⭐ Added to Favorites');
      } else {
        list.splice(idx, 1);
        items = items.filter(i => String(i.id) !== sid);
        showToast('Removed from Favorites');
      }

      this.save(list, items);
      this.updateCount();
      this.syncButtons();
      this.renderPage();
      if (window.BW && window.BW.WishlistDrawer) {
        window.BW.WishlistDrawer.render();
      }
      return idx === -1;
    },
    updateCount() {
      const count = this.get().length;
      qsa('[data-wishlist-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },
    syncButtons() {
      qsa('[data-wish-btn]').forEach(btn => {
        const id = btn.dataset.wishBtn;
        btn.classList.toggle('wished', this.has(id));
      });
    },
    renderPage() {
      const grid = qs('#wishlist-grid');
      const emptyState = qs('#wishlist-empty-state');
      if (!grid) return;

      const items = this.getItems();
      if (items.length === 0) {
        grid.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      if (emptyState) emptyState.style.display = 'none';
      grid.style.display = 'grid';

      grid.innerHTML = items.map(item => `
        <div class="product-card" data-product-id="${item.id}">
          <div class="product-card__badge-bar">
            <span class="card-badge card-badge--gold">SAVED FAVORITE</span>
          </div>
          <button class="product-card__wishlist wished" type="button" data-wish-btn="${item.id}" aria-label="Remove from Wishlist">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="var(--bw-gold)" stroke="var(--bw-gold)" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
          <div class="product-card__media">
            <a href="${item.url || '/collections/all'}"><img src="${item.image || ''}" alt="${item.title}"></a>
          </div>
          <div class="product-card__info">
            <div class="product-card__brand">Football Cleats</div>
            <h3 class="product-card__title"><a href="${item.url || '/collections/all'}">${item.title}</a></h3>
            <div class="product-card__sizes-wrapper">
              <div class="product-card__sizes-meta"><span class="sizes-meta__label">UK SIZES:</span><span class="sizes-meta__range">4 – 11.5</span></div>
              <div class="product-card__sizes-track">
                ${['4','4.5','5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5'].map(s => `
                  <button type="button" class="size-chip ${s === '8' ? 'selected' : ''}" data-size="UK ${s}" title="UK ${s}">${s}</button>
                `).join('')}
              </div>
            </div>
            <div class="product-card__price-row">
              <div class="product-card__price"><span class="price-current">${formatMoney(item.price)}</span></div>
              <button class="bw-btn bw-btn-gold product-card__btn" type="button" data-quick-add data-title="${item.title}" data-price="${item.price}" data-image="${item.image}">+ ADD</button>
            </div>
          </div>
        </div>
      `).join('');
    }
  };

  /* ── Server & Local Cart Sync Engine ─────────────────────────── */
  const CartSync = {
    async fetchServerCart() {
      try {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return null;
        return await res.json();
      } catch (err) {
        return null;
      }
    },

    async updateServerQty(keyOrId, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: keyOrId, quantity: Math.max(0, quantity) })
        });
        if (!res.ok) return null;
        return await res.json();
      } catch (err) {
        return null;
      }
    },

    async addServerItem(variantId, quantity = 1, size = 'UK 8') {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: variantId, quantity: quantity, properties: { Size: size } })
        });
        if (!res.ok) return null;
        return await res.json();
      } catch (err) {
        return null;
      }
    }
  };

  /* ── Local Cart Store (Persistent fallback & sync) ───────────── */
  const LocalCart = {
    get() {
      try { return JSON.parse(localStorage.getItem(MOCK_CART_KEY)) || []; }
      catch { return []; }
    },
    save(items) {
      localStorage.setItem(MOCK_CART_KEY, JSON.stringify(items));
    },
    addItem(item) {
      const items = this.get();
      const existing = items.find(i => i.title === item.title && i.size === item.size);
      if (existing) {
        existing.quantity += (item.quantity || 1);
        existing.isNewUnsynced = true;
      } else {
        items.push({
          key: item.key || ('item_' + Date.now() + '_' + Math.random().toString(36).substr(2, 4)),
          title: item.title,
          price: item.price,
          image: item.image,
          size: item.size || 'UK 8',
          quantity: item.quantity || 1,
          variant_id: item.variant_id || null,
          isNewUnsynced: true
        });
      }
      this.save(items);
      return items;
    },
    updateQty(key, quantity) {
      let items = this.get();
      if (quantity <= 0) {
        items = items.filter(i => i.key !== key && i.variant_id !== key);
      } else {
        const item = items.find(i => i.key === key || i.variant_id === key);
        if (item) {
          item.quantity = quantity;
          item.isNewUnsynced = true;
        }
      }
      this.save(items);
      return items;
    },
    clear() {
      localStorage.removeItem(MOCK_CART_KEY);
    }
  };

  /* ── Cart Drawer & UI Renderer ───────────────────────────────── */
  const CartDrawer = {
    el: null,
    overlay: null,
    bodyEl: null,

    init() {
      this.el      = qs('#cart-drawer') || qs('.cart-drawer');
      this.overlay = qs('#cart-drawer-overlay') || qs('.cart-overlay, .cart-drawer-overlay');
      this.bodyEl  = qs('#cart-drawer-body') || qs('#cart-drawer .cart-drawer__body');

      document.addEventListener('click', e => {
        if (e.target.closest('[data-open-cart]')) { e.preventDefault(); this.open(); }
        if (e.target.closest('.cart-overlay') || e.target.closest('.cart-drawer-overlay') || e.target.closest('[data-close-cart]')) this.close();
      });

      // Delegate quantity buttons inside cart drawer
      if (this.bodyEl) {
        this.bodyEl.addEventListener('click', async e => {
          const btn = e.target.closest('.cart-qty-btn');
          if (!btn) return;
          const key = btn.dataset.key;
          const action = btn.dataset.action;
          const qtyEl = btn.parentElement.querySelector('span');
          let currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
          let newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
          
          if (key) {
            await CartSync.updateServerQty(key, newQty);
          }
          LocalCart.updateQty(key, newQty);
          await this.render();
        });
      }

      this.render();
    },

    async open() {
      await this.render();
      document.body.classList.add('drawer-open');
      if (this.el) this.el.classList.add('open');
      if (this.overlay) this.overlay.classList.add('visible');
    },

    close() {
      document.body.classList.remove('drawer-open');
      if (this.el) this.el.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('visible');
    },

    async render() {
      // Fetch live Shopify server cart data to keep 100% in sync
      let serverCart = null;
      try {
        serverCart = await CartSync.fetchServerCart();
      } catch (err) {
        serverCart = null;
      }

      let serverItems = [];
      if (serverCart && Array.isArray(serverCart.items) && serverCart.items.length > 0) {
        serverItems = serverCart.items.map(item => ({
          key: item.key || String(item.id),
          title: item.product_title || item.title || 'Football Boot',
          price: (item.line_price && item.quantity) ? (item.line_price / item.quantity) : (item.price || 19999),
          image: item.image || item.featured_image?.url || (typeof item.featured_image === 'string' ? item.featured_image : '') || '',
          size: item.variant_title || item.properties?.Size || 'UK 8',
          quantity: item.quantity || 1,
          variant_id: item.variant_id || item.id
        }));
      }

      let localItems = LocalCart.get() || [];

      // Combine server and local items into unified items list
      let combinedMap = new Map();
      localItems.forEach(item => {
        const idKey = String(item.variant_id || item.key || (item.title + '_' + item.size));
        combinedMap.set(idKey, { ...item, key: item.key || idKey });
      });
      serverItems.forEach(item => {
        const idKey = String(item.variant_id || item.key || (item.title + '_' + item.size));
        combinedMap.set(idKey, { ...item, key: item.key || idKey });
      });

      let items = Array.from(combinedMap.values());

      // If server cart exists and explicitly has 0 items, clear local cart if it was stale
      if (serverCart && Array.isArray(serverCart.items) && serverCart.items.length === 0 && serverItems.length === 0) {
        // If server confirms 0 items and local cart was from previous session
        if (localItems.every(i => !i.isNewUnsynced)) {
          items = [];
          LocalCart.clear();
        }
      }

      if (items.length > 0) {
        LocalCart.save(items);
      }

      const totalCount = items.reduce((sum, i) => sum + (parseInt(i.quantity, 10) || 1), 0);

      // Update badge counts across page
      qsa('[data-cart-count]').forEach(el => {
        el.textContent = totalCount;
      });

      if (!this.bodyEl) return;

      if (items.length === 0) {
        this.bodyEl.innerHTML = `
          <div class="cart-empty-msg" style="text-align:center; padding: 48px 20px; color: var(--bw-muted);">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--bw-gold)" stroke-width="1.5" style="margin-bottom: 12px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            <p style="font-size: 1rem; font-weight: 700; color: var(--bw-text); margin-bottom: 6px;">Your Boot Bag is Empty</p>
            <p style="font-size: 0.85rem; margin-bottom: 16px;">Explore our collection and add your favorite boots!</p>
            <a href="/collections/all" class="bw-btn bw-btn-gold bw-btn-sm">START SHOPPING ➔</a>
          </div>
        `;
        qsa('[data-cart-subtotal]').forEach(subtotalEl => {
          subtotalEl.textContent = '₹0';
        });
        return;
      }

      let subtotal = 0;
      const html = items.map(item => {
        const numericPrice = parsePriceToRupees(item.price);
        const qty = parseInt(item.quantity, 10) || 1;
        const lineTotal = numericPrice * qty;
        subtotal += lineTotal;

        const imgUrl = item.image || 'https://cdn.shopify.com/s/files/1/0890/0000/0000/files/placeholder.jpg';

        return `
          <div class="cart-item" data-key="${item.key}" style="display:flex; gap:12px; align-items:center; padding:12px 0; border-bottom:1px solid var(--bw-border);">
            <img class="cart-item__img" src="${imgUrl}" alt="${item.title}" style="width:70px; height:70px; object-fit:cover; border-radius:6px;" onerror="this.src='https://cdn.shopify.com/s/files/1/0890/0000/0000/files/placeholder.jpg'">
            <div style="flex:1;">
              <div class="cart-item__title" style="font-weight:700; font-size:0.85rem; line-height:1.3; color:var(--bw-text);">${item.title}</div>
              <div class="cart-item__meta" style="font-size:0.75rem; color:var(--bw-muted); margin-top:2px;">Size: ${item.size || 'UK 8'}</div>
              <div class="cart-item__qty" style="display:inline-flex; align-items:center; gap:8px; margin-top:6px; background:var(--bw-bg-2); border:1px solid var(--bw-border); border-radius:4px; padding:2px 8px;">
                <button type="button" class="cart-qty-btn" data-action="decrease" data-key="${item.key}" style="background:none;border:none;color:var(--bw-gold);font-weight:bold;cursor:pointer;font-size:1rem;">-</button>
                <span style="font-weight:700; font-size:0.85rem; color:var(--bw-text);">${qty}</span>
                <button type="button" class="cart-qty-btn" data-action="increase" data-key="${item.key}" style="background:none;border:none;color:var(--bw-gold);font-weight:bold;cursor:pointer;font-size:1rem;">+</button>
              </div>
            </div>
            <div class="cart-item__price" style="font-weight:800; color:var(--bw-gold); font-size:0.9rem;">${formatMoney(lineTotal)}</div>
          </div>
        `;
      }).join('');

      this.bodyEl.innerHTML = html;

      // Subtotal - update all matching elements on page
      qsa('[data-cart-subtotal]').forEach(subtotalEl => {
        subtotalEl.textContent = formatMoney(subtotal);
      });
    }
  };

  /* ── Mobile Nav Drawer ────────────────────────────────────────── */
  const MobileNav = {
    drawer: null,
    overlay: null,

    init() {
      this.drawer  = qs('.nav-drawer');
      this.overlay = qs('.nav-overlay');
      if (!this.drawer) return;

      document.addEventListener('click', e => {
        if (e.target.closest('.hamburger-btn')) this.toggle();
        if (e.target.closest('.nav-overlay') || e.target.closest('[data-close-nav]')) this.close();

        // Submenu accordion toggle handler
        const toggleBtn = e.target.closest('[data-toggle-sub]');
        if (toggleBtn) {
          e.preventDefault();
          const itemGroup = toggleBtn.closest('.nav-drawer__item-group');
          if (itemGroup) {
            const sub = qs('.nav-drawer__sub', itemGroup);
            const isOpen = toggleBtn.classList.contains('open');
            toggleBtn.classList.toggle('open', !isOpen);
            toggleBtn.setAttribute('aria-expanded', !isOpen);
            if (sub) sub.classList.toggle('open', !isOpen);
          }
        }
      });
    },

    toggle() {
      this.drawer.classList.contains('open') ? this.close() : this.open();
    },

    open() {
      document.body.classList.add('nav-open');
      this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('visible');
    },

    close() {
      document.body.classList.remove('nav-open');
      this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('visible');
    }
  };

  /* ── Quick Add & PDP Size Handling ───────────────────────────── */
  function initQuickAdd() {
    // Size selection on product cards, quick add modal, and PDP
    document.addEventListener('click', async e => {
      const sizeElem = e.target.closest('.size-chip, .size-btn, .pdp-size-btn');
      if (sizeElem) {
        const container = sizeElem.closest('.product-card__sizes-track, .product-card__sizes-wrapper, .product-card__sizes, .size-selector, .pdp-size-grid');
        if (container) {
          qsa('.size-chip, .size-btn, .pdp-size-btn', container).forEach(c => c.classList.remove('selected'));
          sizeElem.classList.add('selected');
        } else {
          qsa('.pdp-size-btn').forEach(c => c.classList.remove('selected'));
          sizeElem.classList.add('selected');
        }

        // If PDP size button, sync display badge, variant id, prices & size guide table
        if (sizeElem.classList.contains('pdp-size-btn')) {
          const rawSize = sizeElem.dataset.size || ('UK ' + (sizeElem.querySelector('.pdp-size-num')?.textContent.trim() || sizeElem.textContent.trim()));
          const displayEl = document.getElementById('pdp-selected-size-display');
          if (displayEl) {
            displayEl.textContent = rawSize;
          }

          const vId = sizeElem.dataset.variantId;
          const layout = sizeElem.closest('.pdp-layout') || document;
          const atcBtn = qs('[data-quick-add], [data-pdp-atc]', layout);
          if (atcBtn) {
            if (vId) atcBtn.dataset.variantId = vId;
            atcBtn.dataset.size = rawSize;
          }
          const buyBtn = qs('[data-pdp-buy-now]', layout);
          if (buyBtn) {
            if (vId) buyBtn.dataset.variantId = vId;
            buyBtn.dataset.size = rawSize;
          }

          // Update price if present
          if (sizeElem.dataset.price) {
            const priceNum = parseInt(sizeElem.dataset.price, 10);
            if (!isNaN(priceNum)) {
              const fmt = formatMoney(priceNum);
              const priceEl = qs('.pdp-info__price', layout);
              if (priceEl) priceEl.textContent = fmt;
            }
          }

          // Highlight row in size guide table
          const cleanNum = rawSize.replace(/[^0-9.]/g, '').trim();
          qsa('.size-guide-mini-table tbody tr').forEach(row => {
            const firstTxt = (row.cells && row.cells[0]) ? row.cells[0].textContent : '';
            if (firstTxt.includes(cleanNum)) {
              row.classList.add('highlight-row');
            } else {
              row.classList.remove('highlight-row');
            }
          });
        }
      }

      // Wishlist toggle
      const wishBtn = e.target.closest('[data-wish-btn]');
      if (wishBtn) {
        e.preventDefault();
        const card = wishBtn.closest('.product-card') || document;
        const id = wishBtn.dataset.wishBtn || ('fav_' + Date.now());
        const title = qs('.product-card__title a, .product-card__title', card)?.textContent?.trim() || 'Football Boot';
        const priceStr = qs('.price-current', card)?.textContent?.trim() || '₹24,995';
        const image = qs('.product-card__media img', card)?.src || '';
        const url = qs('.product-card__media a', card)?.getAttribute('href') || '/collections/all';

        Wishlist.toggle(id, { id, title, price: priceStr, image, url });
      }

      // Add to Cart (+ ADD button)
      const addBtn = e.target.closest('[data-quick-add]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();

        const card = addBtn.closest('.product-card, .pdp-layout') || document;
        const title = addBtn.dataset.title || qs('.product-card__title, .pdp-info__title', card)?.textContent?.trim() || 'Bootworld Cleats';
        const priceStr = addBtn.dataset.price || qs('.price-current, .pdp-info__price', card)?.textContent?.trim() || '₹24,995';
        const image = addBtn.dataset.image || qs('.product-card__media img, #pdp-main-img', card)?.src || '';
        const variantId = addBtn.dataset.variantId || null;

        // Get selected size chip or pdp button
        const selectedChip = qs('.size-chip.selected, .size-btn.selected, .pdp-size-btn.selected', card);
        let selectedSize = addBtn.dataset.size || 'UK 8';
        if (selectedChip) {
          if (selectedChip.dataset.size) {
            selectedSize = selectedChip.dataset.size;
          } else {
            const rawText = selectedChip.textContent.trim();
            selectedSize = rawText.toLowerCase().includes('uk') ? rawText : ('UK ' + rawText);
          }
        }

        const qty = parseInt(qs('#pdp-qty-val', card)?.value || '1', 10) || 1;

        // Add to Shopify cart API if variantId exists
        if (variantId) {
          await CartSync.addServerItem(variantId, qty, selectedSize);
        }

        LocalCart.addItem({
          title: title,
          price: priceStr,
          image: image,
          size: selectedSize,
          quantity: qty,
          variant_id: variantId
        });

        await CartDrawer.open();
        showToast(`⚡ Added ${title} (${selectedSize} × ${qty}) to Bag!`);
      }

      // PDP Buy Now Button
      const buyNowBtn = e.target.closest('[data-pdp-buy-now]');
      if (buyNowBtn) {
        e.preventDefault();
        e.stopPropagation();

        const layout = buyNowBtn.closest('.pdp-layout') || document;
        const selectedBtn = qs('.pdp-size-btn.selected', layout);
        const selectedSize = selectedBtn?.dataset.size || qs('#pdp-selected-size-display')?.textContent.trim() || 'UK 8';
        const variantId = selectedBtn?.dataset.variantId || buyNowBtn.dataset.variantId || null;
        const title = qs('.pdp-info__title', layout)?.textContent?.trim() || 'Bootworld Cleats';
        const priceStr = qs('.pdp-info__price', layout)?.textContent?.trim() || '₹21,999';
        const image = qs('#pdp-main-img', layout)?.src || '';
        const qty = parseInt(qs('#pdp-qty-val', layout)?.value || '1', 10) || 1;

        buyNowBtn.textContent = 'CHECKING OUT… ⚡';
        buyNowBtn.disabled = true;

        const itemObj = {
          title: title,
          price: priceStr,
          image: image,
          size: selectedSize,
          qty: qty,
          quantity: qty,
          variant_id: variantId
        };

        try {
          sessionStorage.setItem('bw_buy_now_item', JSON.stringify(itemObj));
        } catch (e) {}

        LocalCart.addItem(itemObj);

        try {
          if (variantId) {
            await CartSync.addServerItem(variantId, qty, selectedSize);
          }
        } catch (err) {
          console.warn('Server cart add failed:', err);
        }

        window.location.href = '/checkout';
      }
    });
  }

  /* ── Tab Switchers ───────────────────────────────────────────── */
  function initTabSwitchers() {
    qsa('[data-tab-group]').forEach(group => {
      const tabs   = qsa('.brand-select-pill, .brand-tab-btn, .tab-btn', group);
      const panels = qsa('[data-tab-panel]', group);

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.tab;
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          panels.forEach(p => {
            p.style.display = p.dataset.tabPanel === target ? '' : 'none';
          });
        });
      });
    });

    // Reset category nav scroll to start so first pill is always visible
    qsa('.category-nav__inner').forEach(bar => {
      bar.scrollLeft = 0;
    });
  }

  /* ── Wishlist Drawer ───────────────────────────────────────────── */
  const WishlistDrawer = {
    el: null,
    overlay: null,
    bodyEl: null,

    init() {
      this.el      = qs('.wishlist-drawer');
      this.overlay = qs('.wishlist-drawer-overlay');
      this.bodyEl  = qs('#wishlist-drawer-body');

      document.addEventListener('click', e => {
        if (e.target.closest('[data-open-wishlist]')) { e.preventDefault(); this.open(); }
        if (e.target.closest('.wishlist-drawer-overlay') || e.target.closest('[data-close-wishlist]')) this.close();
      });

      this.render();
    },

    open() {
      this.render();
      document.body.classList.add('wishlist-open');
      if (this.el) this.el.classList.add('open');
      if (this.overlay) this.overlay.classList.add('visible');
    },

    close() {
      document.body.classList.remove('wishlist-open');
      if (this.el) this.el.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('visible');
    },

    render() {
      if (!this.bodyEl) return;
      const items = Wishlist.getItems();

      if (items.length === 0) {
        this.bodyEl.innerHTML = `
          <div style="text-align:center; padding: 48px 20px; color: var(--bw-muted);">
            <div style="font-size: 3rem; margin-bottom: 12px;">💔</div>
            <p style="font-size: 1rem; font-weight: 700; color: var(--bw-text); margin-bottom: 6px;">Your Favorites List is Empty</p>
            <p style="font-size: 0.85rem; margin-bottom: 16px;">Tap the heart icon on any boot to save it here!</p>
            <a href="/collections/all" class="bw-btn bw-btn-gold bw-btn-sm" data-close-wishlist>EXPLORE BOOTS ➔</a>
          </div>
        `;
        return;
      }

      this.bodyEl.innerHTML = items.map(item => `
        <div class="cart-item" data-key="${item.id}" style="display:flex; gap:12px; align-items:center; padding:12px 0; border-bottom:1px solid var(--bw-border);">
          <img class="cart-item__img" src="${item.image || ''}" alt="${item.title}" style="width:64px; height:64px; object-fit:cover; border-radius:6px;">
          <div style="flex:1;">
            <div class="cart-item__title" style="font-weight:700; font-size:0.85rem; line-height:1.3; color:var(--bw-text);">${item.title}</div>
            <div style="font-weight:800; color:var(--bw-gold); font-size:0.88rem; margin-top:2px;">${formatMoney(item.price)}</div>
            <button type="button" class="bw-btn bw-btn-gold bw-btn-sm" data-quick-add data-title="${item.title}" data-price="${item.price}" data-image="${item.image}" style="margin-top:6px; padding:4px 12px; font-size:0.72rem;">+ ADD TO BAG</button>
          </div>
          <button type="button" class="cart-item__remove" onclick="window.BW.Wishlist.toggle('${item.id}')" style="background:none; border:none; color:#e74c3c; cursor:pointer; font-size:1.1rem; padding:4px;">✕</button>
        </div>
      `).join('');
    }
  };

  /* ── Dedicated Best Sellers Marketing Page Script ─────────────── */
  function initBestSellersPage() {
    const pageContainer = qs('#best-sellers-page');
    if (!pageContainer) return;

    // 1. Filter Pills Logic
    const filterPills = qsa('[data-bs-filter]', pageContainer);
    const productCards = qsa('.product-card', pageContainer);
    const countBadge = qs('#bs-count-badge', pageContainer);

    filterPills.forEach(pill => {
      pill.addEventListener('click', () => {
        filterPills.forEach(p => {
          p.classList.remove('active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-selected', 'true');

        const filter = pill.dataset.bsFilter;
        let visibleCount = 0;

        productCards.forEach(card => {
          const category = card.dataset.category || '';
          const surface  = card.dataset.surface || '';
          const priceVal = parseInt(card.dataset.price || '999999', 10);

          let match = false;
          if (filter === 'all') {
            match = true;
          } else if (filter === 'nike' && category.includes('nike')) {
            match = true;
          } else if (filter === 'adidas' && category.includes('adidas')) {
            match = true;
          } else if (filter === 'puma' && category.includes('puma')) {
            match = true;
          } else if (filter === 'fg' && surface.includes('fg')) {
            match = true;
          } else if (filter === 'tf' && surface.includes('tf')) {
            match = true;
          } else if (filter === 'under20k' && priceVal <= 20000) {
            match = true;
          }

          if (match) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });

        if (countBadge) {
          countBadge.textContent = `Showing ${visibleCount} Top-Rated ${visibleCount === 1 ? 'Cleat' : 'Cleats'}`;
        }
      });
    });

    // 2. Copy Promo Code Logic
    const copyBtn = qs('#bs-copy-code-btn', pageContainer);
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        const promoCode = qs('#bs-promo-code', pageContainer)?.textContent?.trim() || 'BESTSELLER10';
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(promoCode);
          } else {
            const tempInput = document.createElement('input');
            tempInput.value = promoCode;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
          }

          const originalText = copyBtn.innerHTML;
          copyBtn.innerHTML = '✓ COPIED!';
          showToast(`🎁 Coupon ${promoCode} Copied! Apply at checkout for extra 10% off.`);
          
          setTimeout(() => {
            copyBtn.innerHTML = originalText;
          }, 3000);
        } catch (err) {
          showToast(`🎁 Code: ${promoCode}`);
        }
      });
    }
  }

  /* ── Hero Multi-Shoe Auto-Loop Showcase Slider ────────────────── */
  function initHeroShoeSlider() {
    const showcase = qs('#hero-shoes-showcase');
    if (!showcase) return;

    const slides = qsa('.hero-shoe-slide', showcase);
    const dots = qsa('.hero-dot', showcase);
    if (slides.length <= 1) return;

    let currentIndex = 0;
    let timer = null;
    const intervalTime = 2000;

    function goToSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex);
    }

    function startAutoPlay() {
      stopAutoPlay();
      timer = setInterval(nextSlide, intervalTime);
    }

    function stopAutoPlay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const slideIdx = parseInt(e.currentTarget.dataset.slide, 10);
        if (!isNaN(slideIdx)) {
          goToSlide(slideIdx);
          startAutoPlay();
        }
      });
    });

    showcase.addEventListener('mouseenter', stopAutoPlay);
    showcase.addEventListener('mouseleave', startAutoPlay);

    startAutoPlay();
  }

  /* ── PDP Size Guide Modal Handling ───────────────────────────── */
  function initSizeGuideModal() {
    const openGuide = () => {
      const modal = document.getElementById('pdp-size-guide-modal');
      if (modal) {
        modal.style.display = 'flex';
        requestAnimationFrame(() => modal.classList.add('visible'));
        document.body.classList.add('modal-open');
      }
    };

    const closeGuide = () => {
      const modal = document.getElementById('pdp-size-guide-modal');
      if (modal) {
        modal.classList.remove('visible');
        document.body.classList.remove('modal-open');
        setTimeout(() => {
          if (!modal.classList.contains('visible')) {
            modal.style.display = 'none';
          }
        }, 250);
      }
    };

    window.openPdpSizeGuide = openGuide;
    window.closePdpSizeGuide = closeGuide;

    document.addEventListener('click', e => {
      if (e.target.closest('.pdp-size-label__guide, [data-open-size-guide]')) {
        e.preventDefault();
        openGuide();
      }
      if (e.target.closest('.size-guide-dialog__close, [data-close-size-guide], #pdp-size-guide-modal .bw-btn-outline')) {
        e.preventDefault();
        closeGuide();
      }
      if (e.target.id === 'pdp-size-guide-modal') {
        closeGuide();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        const modal = document.getElementById('pdp-size-guide-modal');
        if (modal && modal.classList.contains('visible')) {
          closeGuide();
        }
      }
    });
  }

  /* ── Init All ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    WishlistDrawer.init();
    MobileNav.init();
    initQuickAdd();
    initSizeGuideModal();
    initTabSwitchers();
    initBestSellersPage();
    initHeroShoeSlider();
    Wishlist.updateCount();
    Wishlist.syncButtons();
    Wishlist.renderPage();

    window.BW = { CartDrawer, WishlistDrawer, LocalCart, Wishlist, showToast, openPdpSizeGuide: window.openPdpSizeGuide, closePdpSizeGuide: window.closePdpSizeGuide };
  });

})();



